/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export type PasswordError = 'empty';

/**
 * Validates the sign-in password. Only presence is checked: the password policy applies when the
 * password is created, and Cognito decides whether it matches. Shared by the form and the login action.
 * @returns The error, or null when the password can be sent
 */
export function validatePassword(password: string): PasswordError | null {
    return password ? null : 'empty';
}
